import Image from "next/legacy/image";

import { knowHowData } from "./data";
import * as S from "./MktLandingPageKnowHowOraganism.style";

export default function MktLandingPageKnowHowOraganism() {
  return (
    <S.Wrapper>
      <S.Text>
        <S.Title>
          <>팀스파르타 고속 성장의 배경에도 그로스 마케팅이 있습니다.</>
        </S.Title>
        <S.MobileWrapper>
          <Image
            src={`${process.env.CDN_BASE_URL}/swcamp/knowHowGraph.png`}
            width={328}
            height={250}
            alt={"knowhow-graph"}
          />
        </S.MobileWrapper>
        <S.Contents>
          {knowHowData.map(({ id, text }) => (
            <p key={id}>{text}</p>
          ))}
        </S.Contents>
      </S.Text>
      <S.DesktopWrapper>
        <Image
          src={`${process.env.CDN_BASE_URL}/swcamp/knowHowGraph.png`}
          width={520}
          height={396}
          alt={"knowhow-graph"}
        />
      </S.DesktopWrapper>
    </S.Wrapper>
  );
}
